export default {
  // 页面标题
  'pages.mall.config.title': '商城配置',
  'pages.mall.config.subtitle': '管理商场认证上报配置(租户-门店-设备-商城)',

  // 统计卡片
  'pages.mall.config.stat.totalConfig': '配置总数',
  'pages.mall.config.stat.tenantCount': '配置租户数',
  'pages.mall.config.stat.deviceCount': '绑定设备数',
  'pages.mall.config.stat.enabledCount': '启用配置',

  // 按钮
  'pages.mall.config.add': '新增配置',
  'pages.mall.config.edit': '编辑',
  'pages.mall.config.delete': '删除',
  'pages.mall.config.save': '保存',
  'pages.mall.config.cancel': '取消',
  'pages.mall.config.confirm': '确定',
  'pages.mall.config.back': '返回',
  'pages.mall.config.detail': '详情',
  'pages.mall.config.regenerate': '重新生成',
  'pages.mall.config.enable': '启用',
  'pages.mall.config.disable': '禁用',

  // 标题
  'pages.mall.config.addTitle': '新增商城配置',
  'pages.mall.config.editTitle': '编辑商城配置',
  'pages.mall.config.detailTitle': '商城配置详情',

  // 提示消息
  'pages.mall.config.message.addSuccess': '新增成功',
  'pages.mall.config.message.addFailed': '新增失败',
  'pages.mall.config.message.editSuccess': '编辑成功',
  'pages.mall.config.message.editFailed': '编辑失败',
  'pages.mall.config.message.deleteSuccess': '删除成功',
  'pages.mall.config.message.deleteFailed': '删除失败',
  'pages.mall.config.message.deleteConfirm': '确定删除此商城配置吗?',
  'pages.mall.config.message.statusSuccess': '状态更新成功',
  'pages.mall.config.message.statusFailed': '状态更新失败',
  'pages.mall.config.message.regenerateSuccess':
    '已提交强制合并,定时任务将处理',
  'pages.mall.config.message.regenerateFailed': '强制合并失败',
  // 合并文件预览/下载(service 层错误文案)
  'pages.mall.config.file.notFound': '文件不存在或未生成',
  'pages.mall.config.file.previewNotText':
    '预览接口未返回文本内容(请检查代理/网关是否已转发 /pos-api)',
  'pages.mall.config.file.downloadNotFile':
    '下载接口未返回文件(请检查代理/网关是否已转发 /pos-api)',

  // 强制合并(received < expected 时)相关
  'pages.mall.config.forceMerge.checkbox': '强制按现有数据合并',
  'pages.mall.config.forceMerge.checkboxTip':
    '勾选后,才允许在缺少部分设备数据时强制合并。合并结果可能不完整,慎用',
  'pages.mall.config.forceMerge.confirmTitle': '确认强制合并?',
  'pages.mall.config.forceMerge.received': '已收到',
  'pages.mall.config.forceMerge.missing': '缺少',
  'pages.mall.config.forceMerge.warning':
    '合并结果将不完整(缺少上述设备的数据),且会被 AAPP 拉取后推送到商场。是否继续?',
  'pages.mall.config.forceMerge.warningShort': '缺少设备',
  'pages.mall.config.forceMerge.confirm': '确定强制合并',
  'pages.mall.config.forceMerge.cancel': '取消',
  'pages.mall.config.forceMerge.disabledTipPrefix': '缺少设备',
  'pages.mall.config.forceMerge.disabledTipSuffix':
    '需勾选「强制按现有数据合并」才能点',
  'pages.mall.config.forceMerge.stillGeneratingTip':
    '文件还在生成中,等生成完毕后再点',
  'pages.mall.config.forceMerge.waitForPullTip':
    '等待设备拉取文件({pulled}/{expected}),全部拉完才能再次生成',

  // 弹窗分组
  'pages.mall.config.divider.basicInfo': '基础信息',
  'pages.mall.config.divider.mallInfo': '商城配置',
  'pages.mall.config.divider.ftpInfo': 'FTP 配置',
  'pages.mall.config.divider.tsmsInfo': 'TSMS (PITX) 凭证',
  'pages.mall.config.divider.smInfo': 'SM 商城参数',
  'pages.mall.config.divider.ayalaInfo': 'AYALA 商城参数',

  // AYALA 商城认证参数(2026-10-27 Ayala 认证批)
  'pages.mall.config.ayalaCompanyCode': '公司代码',
  'pages.mall.config.ayalaCccode': 'CCCODE(公司代码+合同号,自动拼接)',
  'pages.mall.config.ayalaContractNo': '合同号(旧版 TXT 前缀)',
  'pages.mall.config.ayalaMerchantName': '商户名(MERCHANT_NAME)',
  'pages.mall.config.ayalaMallAddress': '商场地址(小票/Z 报表用)',
  'pages.mall.config.ayalaBirList':
    '每终端 BIR 凭证(按绑定设备档案自动生成:终端号/序列号/使用许可证号 PTU,无需录入)',
  'pages.mall.config.ayalaBirTerNo': '终端号',
  'pages.mall.config.ayalaBirPermitNo': 'BIR Permit No.(设备 PTU)',
  'pages.mall.config.ayalaBirSerialNo': 'Serial No.(设备序列号)',
  'pages.mall.config.form.ayalaCompanyCodeRequired': '请输入公司代码',
  'pages.mall.config.form.ayalaContractNoRequired': '请输入合同号',
  'pages.mall.config.form.ayalaMerchantNameRequired': '请输入商户名',
  'pages.mall.config.form.ayalaParamTip':
    'AYALA 为局域网拉取模式:门店 Windows 机运行 Ayala.exe,每小时准点从 APOS 拉取销售数据,本地组装新版 CSV 与旧版 TXT 认证文件。每终端 BIR 凭证(Z 报表与 EOD 汇总小票用)自动取自绑定设备档案——终端号=设备终端号、Serial No.=设备序列号、BIR Permit No.=设备使用许可证号(PTU),如需调整请在设备档案中维护。',

  // SM(Mosaic SIA) 展示口径参数(2026-09-28 SM 云端链路批)
  'pages.mall.config.smSalesType': 'SM Sales Type',
  'pages.mall.config.form.smSalesTypeRequired': '请选择 SM Sales Type',
  'pages.mall.config.form.smParamTip':
    'SM 为行级上云模式:收银端逐行上传,云端按月合并 T/D 两类 CSV;Sales Type 随 GET /pos/mall/config 下发收银端拼行用,留空时收银端用本地默认(SM01)',
  'pages.mall.config.detail.smNoDetail':
    'SM 商城为行级上云模式, 无商城配置详情页(文件由商城侧工具拉取生成)',

  // 表单字段
  'pages.mall.config.tenant': '所属租户',
  'pages.mall.config.store': '所属门店',
  'pages.mall.config.deviceCodes': '绑定设备',
  'pages.mall.config.mallCode': '所属商城',
  'pages.mall.config.mallName': '商场名称',
  'pages.mall.config.mallPartnerCode': '商场合作伙伴代码',
  'pages.mall.config.businessType': '门店经营类型',
  'pages.mall.config.businessType.food': '餐饮食品',
  'pages.mall.config.businessType.nonFood': '非食品',
  'pages.mall.config.businessType.groceries': '杂货超市',
  'pages.mall.config.businessType.medicines': '药品',
  'pages.mall.config.businessType.nonDrugSale': '非药品销售',
  'pages.mall.config.businessType.drugSale': '药品销售',
  'pages.mall.config.businessType.others': '其他',
  'pages.mall.config.status': '状态',
  'pages.mall.config.ftpHost': 'FTP 地址',
  'pages.mall.config.ftpPort': 'FTP 端口',
  'pages.mall.config.ftpUser': 'FTP 用户名',
  'pages.mall.config.ftpPassword': 'FTP 密码',
  'pages.mall.config.ftpRemoteDir': 'FTP 远程目录',
  'pages.mall.config.ftpUseFtps': '是否启用 FTPS',
  'pages.mall.config.remark': '备注',
  'pages.mall.config.statusEnabled': '启用',
  'pages.mall.config.statusDisabled': '禁用',

  // 表单占位
  'pages.mall.config.form.input': '请输入',
  'pages.mall.config.form.selectPlaceholder': '请选择',
  'pages.mall.config.form.deviceCodesPlaceholder': '请先选门店',
  'pages.mall.config.form.tenantRequired': '请选择租户',
  'pages.mall.config.form.storeRequired': '请选择门店',
  'pages.mall.config.form.deviceCodesRequired': '请至少选择一台设备',
  'pages.mall.config.form.mallCodeRequired': '请选择所属商城',
  'pages.mall.config.form.mallNameRequired': '请输入商场名称',
  'pages.mall.config.form.mallPartnerCodeRequired': '请输入商场合作伙伴代码',
  'pages.mall.config.form.businessTypeRequired': '请选择门店经营类型',
  'pages.mall.config.form.passwordKeepPlaceholder': '留空表示保留原密码',
  'pages.mall.config.form.useFtpsLabel': '使用 FTPS(SSL/TLS 加密)',
  'pages.mall.config.tsmsTenantId': 'TSMS 商户 ID (tenantId)',
  'pages.mall.config.tsmsBaseUrl': 'TSMS API 地址 (baseUrl)',
  'pages.mall.config.tsmsTerminalId': '终端 ID (terminalId)',
  'pages.mall.config.tsmsApiToken': 'API Token',
  'pages.mall.config.form.tsmsTenantIdRequired': '请输入 TSMS 商户 ID',
  'pages.mall.config.form.tsmsTerminalNoMissing':
    '设备 {device} 未维护终端号或终端号不是纯数字, 请先到「设备管理」修正',
  'pages.mall.config.form.tsmsBaseUrlRequired': '请输入 TSMS API 地址',
  'pages.mall.config.form.tsmsApiTokenRequired': '请输入 API Token',
  'pages.mall.config.form.tsmsTerminalIdAutoTip':
    '每台绑定设备的终端 ID 在保存时自动取设备档案的终端号, 无需手填。',

  // 表格列
  'pages.mall.config.column.deviceCodes': '设备编码',
  'pages.mall.config.column.deviceTerminalNos': '终端号',
  'pages.mall.config.column.mall': '商场',
  'pages.mall.config.column.businessType': '经营类型',
  'pages.mall.config.column.status': '状态',
  'pages.mall.config.column.createTime': '创建时间',
  'pages.mall.config.column.updateTime': '更新时间',
  'pages.mall.config.column.action': '操作',

  // 详情页 - 合并任务历史
  'pages.mall.config.detail.basicInfo': '基础信息',
  'pages.mall.config.detail.history': '合并任务历史',
  'pages.mall.config.detail.historyDateRange': '业务日期范围',
  'pages.mall.config.detail.col.businessDate': '业务日期',
  'pages.mall.config.detail.col.fileType': '文件类型',
  'pages.mall.config.detail.col.expected': '应到',
  'pages.mall.config.detail.col.received': '实到',
  'pages.mall.config.detail.col.taskStatus': '任务状态',
  'pages.mall.config.detail.col.processTime': '处理时间',
  'pages.mall.config.detail.col.mergedFile': '合并文件',
  'pages.mall.config.detail.col.action': '操作',

  // 详情页主表新列(8 列结构)
  'pages.mall.config.detail.col.mall': '商城',
  'pages.mall.config.detail.col.device': '设备',
  'pages.mall.config.detail.col.terminalNos': '终端号',
  'pages.mall.config.detail.col.generateFiles': '生成文件',
  'pages.mall.config.detail.col.generateCount': '生成次数',
  'pages.mall.config.detail.col.dataSource': '数据来源',
  'pages.mall.config.detail.col.status': '状态',

  // 主表固定文案
  'pages.mall.config.detail.dataSource.value': 'Z-reading',
  'pages.mall.config.detail.generateFiles.value': 'S/H/D/Z',

  // 主表聚合状态文案
  'pages.mall.config.detail.status.generated': '已生成',
  'pages.mall.config.detail.status.failed': '生成失败',
  'pages.mall.config.detail.status.processing': '处理中',
  'pages.mall.config.detail.status.waitingDevice': '等待设备上传',

  // 详情抽屉(点业务日期弹出)
  'pages.mall.config.detail.drawer.title': '{date} 生成明细',
  'pages.mall.config.detail.drawer.businessDate': '业务日期',
  'pages.mall.config.detail.drawer.mallName': '绑定商城',
  'pages.mall.config.detail.drawer.files': '生成内容',
  'pages.mall.config.detail.drawer.filesSuffix': '文件',
  'pages.mall.config.detail.drawer.generateCount': '生成次数',
  'pages.mall.config.detail.drawer.countSuffix': ' 次',
  'pages.mall.config.detail.drawer.generationLabel': '第 {n} 次',
  'pages.mall.config.detail.drawer.col.generationNo': '生成次数',
  'pages.mall.config.detail.drawer.col.processTime': '生成时间',
  'pages.mall.config.detail.drawer.col.files': '生成文件',
  'pages.mall.config.detail.drawer.col.action': '操作',
  'pages.mall.config.detail.drawer.downloadLogTitle': '已拉取设备',
  'pages.mall.config.detail.drawer.noDownloadLog':
    '暂无拉取记录(设备还未拉过合并文件)',
  'pages.mall.config.detail.drawer.downloadBtn': '下载',
  'pages.mall.config.detail.drawer.downloadSuccess': '下载成功',
  'pages.mall.config.detail.drawer.downloadFailed': '下载失败',
  'pages.mall.config.detail.drawer.downloadNoFiles': '该次生成暂无可下载的文件',

  // 详情抽屉 - 手动推送 FTP
  'pages.mall.config.detail.drawer.pushFtpBtn': '推送FTP',
  'pages.mall.config.detail.drawer.pushFtpMissingTip':
    'S/H/D/Z 4 个文件未齐,无法推送',
  'pages.mall.config.detail.drawer.pushFtpConfirmTitle': '确认推送到商场 FTP?',
  'pages.mall.config.detail.drawer.pushFtpConfirmHost': '目标 FTP',
  'pages.mall.config.detail.drawer.pushFtpConfirmRemoteDir': '远程目录',
  'pages.mall.config.detail.drawer.pushFtpConfirmFiles': '将推送文件',
  'pages.mall.config.detail.drawer.pushFtpConfirmWarning':
    '点击确认后,4 个文件将立刻上传到商场 FTP。任一失败会自动回滚已传文件。',
  'pages.mall.config.detail.drawer.pushFtpConfirm': '确认推送',
  'pages.mall.config.detail.drawer.pushFtpCancel': '取消',
  'pages.mall.config.detail.drawer.pushFtpPushing': '推送中...',
  'pages.mall.config.detail.drawer.pushFtpSuccess': '推送成功',
  'pages.mall.config.detail.drawer.pushFtpFailed': '推送失败',

  // 详情页 - 文件预览
  'pages.mall.config.detail.preview': '预览',
  'pages.mall.config.detail.previewTitle': '{fileType} 文件预览 - {date}',
  'pages.mall.config.detail.previewEmpty': '暂无内容',
  'pages.mall.config.detail.previewLoading': '加载中...',
  'pages.mall.config.detail.previewFileMissing': '文件未生成,无法预览',
  'pages.mall.config.detail.previewBtn': '{fileType}预览',

  // 任务状态文案
  'pages.mall.config.taskStatus.waiting': '等待中',
  'pages.mall.config.taskStatus.merging': '合并中',
  'pages.mall.config.taskStatus.success': '成功',
  'pages.mall.config.taskStatus.failed': '失败',
};
